import format from 'date-fns/format';

/**
 * Returns the status and changed by information formatted as a string.
 *
 * @param {string} status - The status of the item.
 * @param {string} changedBy - The name of the person who made the change.
 * @param {string} date - The date and time when the change was made.
 * @returns {string} - The formatted status and changed by information.
 */
export default (status, changedBy, date) => {
  if (changedBy) {
    return `${status} - ${changedBy} ${format(date, 'DD.MM.YYYY, HH:mm')}`;
  }
  return status;
};
